import { useQuery } from '@apollo/client';
import { GetLatestRiskAssessmentResultConfigDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

interface RiskAssessmentResultConfig {
  likelihood: {
    ratings: {
      title: string;
      description?: string;
      value: number;
      color: string;
    }[];
  };
  impact: {
    ratings: {
      title: string;
      description?: string;
      value: number;
      color: string;
    }[];
    categories: {
      name: string;
      color: string;
    }[];
  };
  matrix: {
    title: string;
    value: number;
    color: string;
    likelihoodImpact: { likelihood: number; impact: number }[];
  }[];
}

export const useGetLatestRiskAssessmentResultConfig = () => {
  const { data, loading } = useQuery(
    GetLatestRiskAssessmentResultConfigDocument
  );

  const config = data?.risk_assessment_result_config[0]?.Config as
    | RiskAssessmentResultConfig
    | undefined;

  return { config, loading };
};
